import { render, staticRenderFns } from "./tabHallFama.vue?vue&type=template&id=6e713c02&scoped=true"
import script from "./tabHallFama.vue?vue&type=script&lang=js"
export * from "./tabHallFama.vue?vue&type=script&lang=js"
import style0 from "./tabHallFama.vue?vue&type=style&index=0&id=6e713c02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e713c02",
  null
  
)

export default component.exports